import React, { useEffect, useRef, useState } from "react";
import { IconButton, Modal } from "@mui/material";
import LeftAligner from "./../assets/left_aligner.png";
import { ReactComponent as ClockIcon } from "./../assets/clock.svg";
import {
  CHECK_ICON_COLOR,
  DESCRIPTION_COLOR,
  PRIMARY_COLOR,
  TEXT_COLOR,
} from "../constants/theme";
import { ReactComponent as PlusIconPrimary } from "./../assets/plus_icon_primary.svg";
import { FaCircleCheck } from "react-icons/fa6";
import { toast } from "react-toastify";
import moment from "moment";
import { useNavigate } from "react-router";
import Config from "../services/config";

const ViewSwitchedAligners = () => {
  const navigate = useNavigate();
  const switchDetails = JSON.parse(sessionStorage.getItem("switchData"));
  const step = switchDetails?.step;
  const alignerData = switchDetails?.alignerSchedule;
  const alignerScheduleId = alignerData?.aligner_schedule_id;
  const alignerMax = Math.max(
    alignerData?.aligners_lower_quantity,
    alignerData?.aligners_upper_quantity
  );
  const email = sessionStorage.getItem("email");
  const caseHistory = sessionStorage.getItem("caseHistory")
    ? JSON.parse(sessionStorage.getItem("caseHistory"))
    : [];
  const [beforeSmilyPic, setBeforeSmilyPic] = useState("");
  const [beforeFrontToothPic, setBeforeFrontToothPic] = useState("");
  const [beforeBuccalLeftPic, setBeforeBuccalLeftPic] = useState("");
  const [beforeBuccalRightPic, setBeforeBuccalRightPic] = useState("");
  const [beforeOcclusalUpperPic, setBeforeOcclusalUpperPic] = useState("");
  const [beforeOcclusalLowerPic, setBeforeOcclusalLowerPic] = useState("");

  const [afterSmilyPic, setAfterSmilyPic] = useState("");
  const [afterFrontToothPic, setAfterFrontToothPic] = useState("");
  const [afterBuccalLeftPic, setAfterBuccalLeftPic] = useState("");
  const [afterBuccalRightPic, setAfterBuccalRightPic] = useState("");
  const [afterOcclusalUpperPic, setAfterOcclusalUpperPic] = useState("");
  const [afterOcclusalLowerPic, setAfterOcclusalLowerPic] = useState("");

  const [screenWidth, setScreenWidth] = useState(0);

  useEffect(() => {
    const resizeWindow = () => {
      setScreenWidth(window?.outerWidth);
    };

    window?.addEventListener("resize", resizeWindow);

    resizeWindow();

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  useEffect(() => {
    let data = JSON.parse(sessionStorage.getItem("switchData"));
    if (!data) {
      toast.error("Error fetching data!");
      navigate("/aligner-schedule");
    }
    let beforeCheck =
      data?.alignerSchedule?.before_aligner_pictures.length > 0
        ? data?.alignerSchedule?.before_aligner_pictures.find(
            (item) => item.step === data?.step
          )
        : undefined;

    let afterCheck =
      data?.alignerSchedule?.with_aligner_pictures.length > 0
        ? data?.alignerSchedule?.with_aligner_pictures.find(
            (item) => item.step === data?.step
          )
        : undefined;

    if (!beforeCheck && !afterCheck) {
      toast.error("Requested step picture not uploaded!");
      navigate("/aligner-schedule");
    }

    if (beforeCheck) {
      setBeforeSmilyPic(beforeCheck?.before_smily_picture);
      setBeforeFrontToothPic(beforeCheck?.before_teeth_picture);
      setBeforeBuccalLeftPic(beforeCheck?.before_buccal_left_picture);
      setBeforeBuccalRightPic(beforeCheck?.before_buccal_right_picture);
      setBeforeOcclusalUpperPic(beforeCheck?.before_occlusal_upper);
      setBeforeOcclusalLowerPic(beforeCheck?.before_occlusal_lower);
    }
    if (afterCheck) {
      setAfterSmilyPic(afterCheck?.after_smily_picture);
      setAfterFrontToothPic(afterCheck?.after_front_teeth_picture);
      setAfterBuccalLeftPic(afterCheck?.after_buccal_left_picture);
      setAfterBuccalRightPic(afterCheck?.after_buccal_right_picture);
      setAfterOcclusalUpperPic(afterCheck?.after_occlusal_upper);
      setAfterOcclusalLowerPic(afterCheck?.after_occlusal_lower);
    }
  }, []);

  return (
    <>
      <div
        className="row w-100 mx-auto flex-column align-items-center justify-content-start"
        style={{
          backgroundColor: "rgb(255, 255, 255)",
          borderRadius: "15px",
        }}
      >
        <div
          className=""
          style={{
            padding: "12px 13px 16px 13px",
          }}
        >
          <div
            className="row w-100 mx-auto flex-column justify-content-start align-items-center"
            style={{
              gap: "25px",
            }}
          >
            <div className="col-12 p-0">
              <div
                className="text-center"
                style={{
                  fontSize: "18px",
                  fontWeight: "400",
                  color: PRIMARY_COLOR,
                  marginBottom: "10px",
                }}
              >
                View Switched Aligners
              </div>

              <div
                className="row w-100 mx-auto flex-column align-items-center justify-content-start"
                style={{
                  gap: "18px",
                }}
              >
                {/* TOP SECTION */}
                <div className="col-12 p-0">
                  <div className="row w-100 mx-auto align-items-center justify-content-center">
                    <div className="col p-0">
                      <div className="row w-100 mx-auto align-items-center justify-content-center">
                        <div className="col-auto p-0">
                          <div
                            className="row w-100 mx-auto flex-column align-items-center justify-content-start"
                            style={{
                              gap: "5px",
                            }}
                          >
                            <div className="col-auto p-0">
                              <img
                                className=""
                                src={LeftAligner}
                                alt="left aligner"
                                style={{
                                  width: "100px",
                                  maxWidth: "100%",
                                  transform: "scale(1, -1) rotate(180deg)",
                                }}
                              />
                            </div>
                            <div className="col-auto p-0">
                              <div
                                className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                                style={{
                                  gap: "2.5px",
                                  paddingRight: "6px",
                                }}
                              >
                                <div className="col-auto p-0">
                                  <div
                                    className="text-center"
                                    style={{
                                      fontSize: "7.5px",
                                      fontWeight: "400",
                                      color: TEXT_COLOR,
                                      lineHeight: "1",
                                    }}
                                  >
                                    {switchDetails?.step <= alignerMax
                                      ? "Aligner Number"
                                      : "Retainer Number"}
                                  </div>
                                </div>
                                <div className="col-auto p-0">
                                  <div
                                    className="text-center"
                                    style={{
                                      fontSize: "13.5px",
                                      fontWeight: "600",
                                      color: TEXT_COLOR,
                                      lineHeight: "1",
                                    }}
                                  >
                                    {switchDetails?.step <= alignerMax
                                      ? alignerData?.aligners_upper_quantity >=
                                        switchDetails?.step
                                        ? `${switchDetails?.step} Upper`
                                        : `No Upper Aligner`
                                      : alignerData?.retainer_upper_quantity >=
                                        switchDetails?.step - alignerMax
                                      ? `${
                                          switchDetails?.step - alignerMax
                                        } Upper`
                                      : `No Upper Retainer`}
                                  </div>
                                </div>
                                <div
                                  className="col-auto p-0"
                                  style={{
                                    marginTop: "3px",
                                  }}
                                >
                                  <div
                                    className="text-center"
                                    style={{
                                      fontSize: "13.5px",
                                      fontWeight: "600",
                                      color: TEXT_COLOR,
                                      lineHeight: "1",
                                    }}
                                  >
                                    {switchDetails?.step <= alignerMax
                                      ? alignerData?.aligners_lower_quantity >=
                                        switchDetails?.step
                                        ? `${switchDetails?.step} Lower`
                                        : `No Lower Aligner`
                                      : alignerData?.retainer_lower_quantity >=
                                        switchDetails?.step - alignerMax
                                      ? `${
                                          switchDetails?.step - alignerMax
                                        } Lower`
                                      : `No Lower Retainer`}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="row w-100 mx-auto flex-column align-items-center justify-content-start"
                  style={{
                    gap: "58px",
                  }}
                >
                  <div
                    className="row w-100 mx-auto flex-column align-items-center justify-content-start"
                    style={{
                      gap: "8px",
                    }}
                  >
                    <div
                      className="text-center"
                      style={{ color: PRIMARY_COLOR }}
                    >
                      <h6>Before (Without Aligner)</h6>
                    </div>
                    <div
                      className="row w-100 mx-auto flex-column flex-sm-row align-items-center justify-content-center"
                      style={{
                        rowGap: "15px",
                        maxWidth: "700px",
                      }}
                    >
                      {beforeSmilyPic && (
                        <div
                          style={{
                            display: screenWidth <= 500 ? "flex" : "",
                            flexDirection: screenWidth <= 500 ? "column" : "",
                            alignItems: screenWidth <= 500 ? "center" : "",
                          }}
                          className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative"
                        >
                          <div
                            id="beforesmily"
                            className={
                              "border justify-content-center align-items-center text-center"
                            }
                            style={{
                              width: "170px",
                              height: "120px",
                              cursor: "pointer",
                              caretColor: "transparent",
                            }}
                          >
                            <img
                              src={Config.filePath + beforeSmilyPic}
                              id="lateralxray"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "120px",
                                maxWidth: "170px",
                              }}
                            />
                          </div>
                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Smile
                          </div>
                        </div>
                      )}

                      {beforeFrontToothPic && (
                        <div
                          style={{
                            display: screenWidth <= 500 ? "flex" : "",
                            flexDirection: screenWidth <= 500 ? "column" : "",
                            alignItems: screenWidth <= 500 ? "center" : "",
                          }}
                          className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                        >
                          <div
                            id="beforefronttooth"
                            className={
                              "border justify-content-center align-items-center text-center"
                            }
                            style={{
                              width: "170px",
                              height: "120px",
                              cursor: "pointer",
                              caretColor: "transparent",
                            }}
                          >
                            <img
                              src={Config.filePath + beforeFrontToothPic}
                              id="lateralxray"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "120px",
                                maxWidth: "170px",
                              }}
                            />
                          </div>

                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Front Tooth
                          </div>
                        </div>
                      )}

                      {beforeBuccalLeftPic && (
                        <div
                          style={{
                            display: screenWidth <= 500 ? "flex" : "",
                            flexDirection: screenWidth <= 500 ? "column" : "",
                            alignItems: screenWidth <= 500 ? "center" : "",
                          }}
                          className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                        >
                          <div
                            id="beforebuccalleft"
                            className={
                              "border border justify-content-center align-items-center text-center"
                            }
                            style={{
                              width: "170px",
                              height: "120px",
                              cursor: "pointer",
                              caretColor: "transparent",
                            }}
                          >
                            <img
                              src={Config.filePath + beforeBuccalLeftPic}
                              id="lateralxray"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "120px",
                                maxWidth: "170px",
                              }}
                            />
                          </div>

                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Buccal Left
                          </div>
                        </div>
                      )}

                      {beforeBuccalRightPic && (
                        <div
                          style={{
                            display: screenWidth <= 500 ? "flex" : "",
                            flexDirection: screenWidth <= 500 ? "column" : "",
                            alignItems: screenWidth <= 500 ? "center" : "",
                          }}
                          className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                        >
                          <div
                            id="beforebuccalright"
                            className={
                              "border justify-content-center align-items-center text-center"
                            }
                            style={{
                              width: "170px",
                              height: "120px",
                              cursor: "pointer",
                              caretColor: "transparent",
                            }}
                          >
                            <img
                              src={Config.filePath + beforeBuccalRightPic}
                              id="lateralxray"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "120px",
                                maxWidth: "170px",
                              }}
                            />
                          </div>

                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Buccal Right
                          </div>
                        </div>
                      )}

                      {beforeOcclusalUpperPic && (
                        <div
                          style={{
                            display: screenWidth <= 500 ? "flex" : "",
                            flexDirection: screenWidth <= 500 ? "column" : "",
                            alignItems: screenWidth <= 500 ? "center" : "",
                          }}
                          className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                        >
                          <div
                            id="beforeocclusalupper"
                            className={
                              "border justify-content-center align-items-center text-center"
                            }
                            style={{
                              width: "170px",
                              height: "120px",
                              cursor: "pointer",
                              caretColor: "transparent",
                            }}
                          >
                            <img
                              src={Config.filePath + beforeOcclusalUpperPic}
                              id="lateralxray"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "120px",
                                maxWidth: "170px",
                              }}
                            />
                          </div>

                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Occlusal Upper
                          </div>
                        </div>
                      )}

                      {beforeOcclusalLowerPic && (
                        <div
                          style={{
                            display: screenWidth <= 500 ? "flex" : "",
                            flexDirection: screenWidth <= 500 ? "column" : "",
                            alignItems: screenWidth <= 500 ? "center" : "",
                          }}
                          className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                        >
                          <div
                            id="beforeocclusallower"
                            className={
                              "border justify-content-center align-items-center text-center"
                            }
                            style={{
                              width: "170px",
                              height: "120px",
                              cursor: "pointer",
                              caretColor: "transparent",
                            }}
                          >
                            <img
                              src={Config.filePath + beforeOcclusalLowerPic}
                              id="lateralxray"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "120px",
                                maxWidth: "170px",
                              }}
                            />
                          </div>

                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Occlusal Lower
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div
                    className="row w-100 mx-auto flex-column align-items-center justify-content-start"
                    style={{
                      gap: "8px",
                    }}
                  >
                    <div
                      className="text-center"
                      style={{ color: PRIMARY_COLOR }}
                    >
                      <h6>After (With New Aligners)</h6>
                    </div>

                    <div
                      className="row w-100 mx-auto flex-column flex-sm-row align-items-center justify-content-center"
                      style={{
                        rowGap: "15px",
                        maxWidth: "700px",
                      }}
                    >
                      {afterSmilyPic && (
                        <div
                          style={{
                            display: screenWidth <= 500 ? "flex" : "",
                            flexDirection: screenWidth <= 500 ? "column" : "",
                            alignItems: screenWidth <= 500 ? "center" : "",
                          }}
                          className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative"
                        >
                          <div
                            id="aftersmily"
                            className={
                              "border justify-content-center align-items-center text-center"
                            }
                            style={{
                              width: "170px",
                              height: "120px",
                              cursor: "pointer",
                              caretColor: "transparent",
                            }}
                          >
                            <img
                              src={Config.filePath + afterSmilyPic}
                              id="lateralxray"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "120px",
                                maxWidth: "170px",
                              }}
                            />
                          </div>

                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Smile
                          </div>
                        </div>
                      )}

                      {afterFrontToothPic && (
                        <div
                          style={{
                            display: screenWidth <= 500 ? "flex" : "",
                            flexDirection: screenWidth <= 500 ? "column" : "",
                            alignItems: screenWidth <= 500 ? "center" : "",
                          }}
                          className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                        >
                          <div
                            id="afterfronttooth"
                            className={
                              "border justify-content-center align-items-center text-center"
                            }
                            style={{
                              width: "170px",
                              height: "120px",
                              cursor: "pointer",
                              caretColor: "transparent",
                            }}
                          >
                            <img
                              src={Config.filePath + afterFrontToothPic}
                              id="lateralxray"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "120px",
                                maxWidth: "170px",
                              }}
                            />
                          </div>

                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Front Tooth
                          </div>
                        </div>
                      )}

                      {afterBuccalLeftPic && (
                        <div
                          style={{
                            display: screenWidth <= 500 ? "flex" : "",
                            flexDirection: screenWidth <= 500 ? "column" : "",
                            alignItems: screenWidth <= 500 ? "center" : "",
                          }}
                          className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                        >
                          <div
                            id="afterbuccalleft"
                            className={
                              "border border justify-content-center align-items-center text-center"
                            }
                            style={{
                              width: "170px",
                              height: "120px",
                              cursor: "pointer",
                              caretColor: "transparent",
                            }}
                          >
                            <img
                              src={Config.filePath + afterBuccalLeftPic}
                              id="lateralxray"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "120px",
                                maxWidth: "170px",
                              }}
                            />
                          </div>

                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Buccal Left
                          </div>
                        </div>
                      )}

                      {afterBuccalRightPic && (
                        <div
                          style={{
                            display: screenWidth <= 500 ? "flex" : "",
                            flexDirection: screenWidth <= 500 ? "column" : "",
                            alignItems: screenWidth <= 500 ? "center" : "",
                          }}
                          className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                        >
                          <div
                            id="afterbuccalright"
                            className={
                              "border justify-content-center align-items-center text-center"
                            }
                            style={{
                              width: "170px",
                              height: "120px",
                              cursor: "pointer",
                              caretColor: "transparent",
                            }}
                          >
                            <img
                              src={Config.filePath + afterBuccalRightPic}
                              id="lateralxray"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "120px",
                                maxWidth: "170px",
                              }}
                            />
                          </div>

                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Buccal Right
                          </div>
                        </div>
                      )}

                      {afterOcclusalUpperPic && (
                        <div
                          style={{
                            display: screenWidth <= 500 ? "flex" : "",
                            flexDirection: screenWidth <= 500 ? "column" : "",
                            alignItems: screenWidth <= 500 ? "center" : "",
                          }}
                          className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                        >
                          <div
                            id="afterocclusalupper"
                            className={
                              "border justify-content-center align-items-center text-center"
                            }
                            style={{
                              width: "170px",
                              height: "120px",
                              cursor: "pointer",
                              caretColor: "transparent",
                            }}
                          >
                            <img
                              src={Config.filePath + afterOcclusalUpperPic}
                              id="lateralxray"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "120px",
                                maxWidth: "170px",
                              }}
                            />
                          </div>

                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Occlusal Upper
                          </div>
                        </div>
                      )}

                      {afterOcclusalLowerPic && (
                        <div
                          style={{
                            display: screenWidth <= 500 ? "flex" : "",
                            flexDirection: screenWidth <= 500 ? "column" : "",
                            alignItems: screenWidth <= 500 ? "center" : "",
                          }}
                          className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                        >
                          <div
                            id="afterocclusallower"
                            className={
                              "border justify-content-center align-items-center text-center"
                            }
                            style={{
                              width: "170px",
                              height: "120px",
                              cursor: "pointer",
                              caretColor: "transparent",
                            }}
                          >
                            <img
                              src={Config.filePath + afterOcclusalLowerPic}
                              id="lateralxray"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "120px",
                                maxWidth: "170px",
                              }}
                            />
                          </div>

                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Occlusal Lower
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* BOTTOM SECTION */}
            <div className="col-12 p-0">
              <div
                className="row w-100 mx-auto flex-column align-items-center justify-content-start"
                style={{
                  gap: "16px",
                }}
              >
                <div className="col-auto p-0">
                  <div
                    className="text-center"
                    style={{
                      fontSize: "12px",
                      color: PRIMARY_COLOR,
                      fontWeight: "normal",
                      lineHeight: "1",
                    }}
                  >
                    {/* Alignment Switch History */}
                    Aligner Switch History
                  </div>
                </div>

                <div
                  className={`${screenWidth > 620 ? "col-8" : "col-auto"} p-0`}
                >
                  <div
                    className="w-100 d-flex flex-column justify-content-start"
                    style={{
                      minHeight: "125px",
                      paddingInline: "8px",
                    }}
                  >
                    <div
                      className="row w-100 mx-auto flex-column justify-content-between align-items-start"
                      style={{
                        color: "rgb(110, 121, 125)",
                        gap: "22px",
                      }}
                    >
                      {Array.from({
                        length: Math.max(
                          Math.max(
                            alignerData?.aligners_lower_quantity,
                            alignerData?.aligners_upper_quantity
                          ) +
                            Math.max(
                              alignerData?.retainer_lower_quantity,
                              alignerData?.retainer_upper_quantity
                            )
                        ),
                      }).map((item, index) => {
                        let IconComponent =
                          index + 1 <
                          alignerData?.before_aligner_pictures?.length
                            ? FaCircleCheck
                            : PlusIconPrimary;

                        return (
                          <div className="col-12 p-0" key={index}>
                            <div
                              className={`row w-100 mx-auto align-items-center justify-content-${
                                screenWidth > 620 ? "between" : "start"
                              }`}
                              style={{
                                gap: "7px",
                              }}
                            >
                              <div className="d-flex col-auto px-0 gap-md-4 gap-2">
                                <div className="col-auto p-0 position-relative">
                                  {index !==
                                    Math.max(
                                      Math.max(
                                        alignerData?.aligners_lower_quantity,
                                        alignerData?.aligners_upper_quantity
                                      ) +
                                        Math.max(
                                          alignerData?.retainer_lower_quantity,
                                          alignerData?.retainer_upper_quantity
                                        )
                                    ) -
                                      1 && (
                                    <div
                                      className="position-absolute"
                                      style={{
                                        width: "0.8px",
                                        height: "20px",
                                        backgroundColor: "rgb(176, 176, 176)",
                                        bottom: "0",
                                        left: "47%",
                                        transform:
                                          "translateY(112%) translateX(0%)",
                                      }}
                                    ></div>
                                  )}
                                  <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{
                                      // height: '21px',
                                      width: "21px",
                                    }}
                                  >
                                    <IconComponent
                                      style={
                                        index + 1 <
                                        alignerData?.before_aligner_pictures
                                          ?.length
                                          ? {
                                              color: CHECK_ICON_COLOR,
                                              height: "100%",
                                              width: "100%",
                                              overflow: "visible",
                                            }
                                          : {
                                              fill: PRIMARY_COLOR,
                                              height: "100%",
                                              width: "100%",
                                              overflow: "visible",
                                            }
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              <div
                                className={`${
                                  screenWidth > 620 ? "col-auto" : "col"
                                } p-0`}
                              >
                                <div
                                  className="row w-100 mx-auto flex-column align-items-start justify-content-center"
                                  style={{
                                    lineHeight: "1",

                                    gap: "3px",
                                  }}
                                >
                                  <div className="col-auto p-0">
                                    <div
                                      className=""
                                      style={{
                                        fontSize: "12px",
                                      }}
                                    >
                                      {/* {item?.title} */}
                                      {index < alignerMax
                                        ? `Aligner ${index + 1}`
                                        : `Retainer ${index - alignerMax + 1}`}
                                    </div>
                                  </div>
                                  <div className="col-auto p-0">
                                    <div
                                      className=""
                                      style={{
                                        fontSize: "8.5px",
                                        // textDecoration: 'underline',
                                        // textDecorationThickness: '0.1em'
                                      }}
                                    >
                                      Status:{" "}
                                      {index + 1 >
                                      alignerData?.before_aligner_pictures
                                        .length
                                        ? `Pending`
                                        : `Switched`}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`col-12 ${screenWidth > 620 ? "" : "col-sm-auto"} p-0`}
            >
              <div
                className="row w-100 mx-auto flex-column align-items-center justify-content-start"
                style={{
                  gap: "18px",
                }}
              >
                <div className="col-auto p-0">
                  <div
                    className="text-center"
                    style={{
                      fontSize: "12px",
                      color: PRIMARY_COLOR,
                      fontWeight: "normal",
                      lineHeight: "1",
                    }}
                  >
                    Case History
                  </div>
                </div>

                {caseHistory &&
                  caseHistory.length > 0 &&
                  caseHistory.map((item) => (
                    <div
                      className="row w-100 mx-auto align-items-center justify-content-start"
                      style={{
                        gap: "22px",
                        minHeight: "70px",
                      }}
                    >
                      <div
                        className="row w-100 mx-auto align-items-center justify-content-center"
                        style={{
                          backgroundColor: "rgb(255, 255, 255)",
                          borderRadius: "15px",
                          // padding: '6px',
                        }}
                      >
                        <div
                          className={`${
                            screenWidth > 620 ? "col-8" : "col-auto"
                          } p-0`}
                        >
                          <div
                            className={`row w-100 mx-auto align-items-start justify-content-${
                              screenWidth > 620 ? "between" : "start"
                            }`}
                            style={{
                              gap: "16px",
                              flexWrap: "nowrap",
                            }}
                          >
                            <div className="d-flex col-auto p-0 gap-3">
                              <div className="col-auto p-0">
                                <div
                                  className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                                  style={{
                                    gap: "6px",
                                  }}
                                >
                                  <div className="col-auto p-0">
                                    <div
                                      className=""
                                      style={{
                                        width: "37px",
                                      }}
                                    >
                                      <ClockIcon
                                        style={{
                                          overflow: "visible",
                                        }}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-auto p-0">
                                    <div
                                      className=""
                                      style={{
                                        lineHeight: "1",
                                        fontSize: "10px",
                                        color: DESCRIPTION_COLOR,
                                        fontWeight: "normal",
                                      }}
                                    >
                                      {item?.case_submit_date
                                        ? moment(item?.case_submit_date).format(
                                            "hh:mm A"
                                          )
                                        : ""}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-auto p-0">
                                <div
                                  className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                                  style={{
                                    lineHeight: "1",
                                  }}
                                >
                                  <div className="col-auto p-0">
                                    <div
                                      className=""
                                      style={{
                                        fontSize: "22px",
                                        color: PRIMARY_COLOR,
                                        fontWeight: "normal",
                                      }}
                                    >
                                      {item?.case_submit_date
                                        ? moment(item?.case_submit_date).format(
                                            "DD"
                                          )
                                        : ""}
                                    </div>
                                  </div>
                                  <div
                                    className="col-auto p-0"
                                    style={{
                                      marginTop: "2.5px",
                                    }}
                                  >
                                    <div
                                      className=""
                                      style={{
                                        fontSize: "14.5px",
                                        color: "#000000",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      {item?.case_submit_date
                                        ? moment(item?.case_submit_date).format(
                                            "MMM"
                                          )
                                        : ""}
                                    </div>
                                  </div>
                                  <div
                                    className="col-auto p-0"
                                    style={{
                                      marginTop: "1px",
                                    }}
                                  >
                                    <div
                                      className=""
                                      style={{
                                        fontSize: "10px",
                                        color: DESCRIPTION_COLOR,
                                        fontWeight: "normal",
                                      }}
                                    >
                                      {item?.case_submit_date
                                        ? moment(item?.case_submit_date).format(
                                            "YYYY"
                                          )
                                        : ""}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-auto p-0">
                              <div
                                className="row w-100 mx-auto flex-column align-items-start justify-content-start"
                                style={{
                                  gap: "8px",
                                  paddingTop: "2px",
                                }}
                              >
                                <div className="col-auto p-0">
                                  <div
                                    className="row w-100 mx-auto flex-column align-items-start"
                                    style={{
                                      lineHeight: "1",
                                      fontWeight: "normal",
                                      gap: "0.5px",
                                    }}
                                  >
                                    <div className="col-auto p-0">
                                      <div
                                        className=""
                                        style={{
                                          fontSize: "9px",
                                          color: DESCRIPTION_COLOR,
                                        }}
                                      >
                                        {/* Treatment */}
                                        Service
                                      </div>
                                    </div>

                                    <div className="col-auto p-0">
                                      <div
                                        className=""
                                        style={{
                                          fontSize: "10px",
                                          color: PRIMARY_COLOR,
                                          minWidth: "125px",
                                          maxWidth: "150px",
                                        }}
                                      >
                                        {/* Root Canal Treatment */}
                                        {item?.service &&
                                        item?.service === "both"
                                          ? "TP / FAB"
                                          : item?.service.toUpperCase()}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-auto p-0">
                                  <div
                                    className="row w-100 mx-auto flex-column align-items-start"
                                    style={{
                                      lineHeight: "1",
                                      fontWeight: "normal",
                                      gap: "0.5px",
                                    }}
                                  >
                                    <div className="col-auto p-0">
                                      <div
                                        className=""
                                        style={{
                                          fontSize: "9px",
                                          color: DESCRIPTION_COLOR,
                                        }}
                                      >
                                        Doctor
                                      </div>
                                    </div>

                                    <div className="col-auto p-0">
                                      <div
                                        className=""
                                        style={{
                                          fontSize: "10px",
                                          color: PRIMARY_COLOR,
                                          minWidth: "125px",
                                          maxWidth: "150px",
                                        }}
                                      >
                                        {/* Adam Jacob - Dentora */}
                                        {item?.doctor_name}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewSwitchedAligners;
